// 多单活动奖励
import { post } from '../axios'

// 分页查询
export function queryPageActivities(map) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/multiOrderRewardsActivity/pageActivities`,
    map
  )
}
// 保存编辑
export function savePageActivities(map) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/multiOrderRewardsActivity/save`,
    map
  )
}
//启用禁用
export function updatePageActivities(map) {
  return post(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/multiOrderRewardsActivity/updateStatus`,
    map
  )
}
